import { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { useStateContext } from "./context/StateContext";

import AnimatedRoutes from "./components/AnimatedRoutes";
import desktop from "./images/illustrations/desktop-background.png";
// import mobile from "./images/illustrations/mobile-background.png";
import mobile from "./images/illustrations/mobile-background-2.png";

import './App.css';
import "./styles/website.scss";
import "./styles/page.scss";

function App() {
  const { menu } = useStateContext();
  const [width, setWidth] = useState(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  return (
    <>
      <img alt="background" src={width <= 950 ? mobile : desktop} className="background" />
      <div className={"App menu " + (menu && "open")}>
        <BrowserRouter>
          <AnimatedRoutes />
        </BrowserRouter>
      </div>
    </>
  );
}

export default App;